import { MatDialogConfig } from "@angular/material/dialog";

export class AppDialogConfig {

    public static getStandardConfiguration() {
        return {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            panelClass: "dialog",
            data: {},
        } as MatDialogConfig;
    }
}